<div>
  @if (isDatasetDownloadEnabled) {
  <mic-breadcrumb id="dataset-download-breadcrumb">
    <mic-breadcrumb-link link="/home/dashboard" icon="home"></mic-breadcrumb-link>
    <mic-breadcrumb-link link="/home/dataset-download" [label]="translationService.translate('datasetDownloadText')"></mic-breadcrumb-link>
  </mic-breadcrumb>
  <div class="pb-2"></div>
  <mic-status class="primary mt-4">{{ translationService.translate('maxDateRangeFromStartDateText') }}<strong>1 Year</strong></mic-status>
  <!-- Section 1: Download All Datasets as a ZIP Archive -->
  <!--  <mat-card class="mt-3">-->
  <!--    <mat-card-content>-->
  <!--      <div class="section-label pb-2">Datasets will automatically be truncated at 20000 lines</div>-->

  <!--      <div class="section-label">Download all datasets as a zip archive</div>-->

  <!--      <form [formGroup]="archiveForm" class="archive-form">-->
  <!--        <mat-form-field appearance="fill" class="date-field">-->
  <!--          <mat-label>Start Date</mat-label>-->
  <!--          <input-->
  <!--            matInput-->
  <!--            [matDatepicker]="archiveStartPicker"-->
  <!--            formControlName="startDate"-->
  <!--            [max]="maxDate"-->
  <!--            placeholder="MM/DD/YYYY"-->
  <!--            autocomplete="off"-->
  <!--          />-->
  <!--          <mat-datepicker-toggle matSuffix [for]="archiveStartPicker"></mat-datepicker-toggle>-->
  <!--          <mat-datepicker #archiveStartPicker></mat-datepicker>-->
  <!--        </mat-form-field>-->

  <!--        <mat-form-field appearance="fill" class="date-field">-->
  <!--          <mat-label>End Date</mat-label>-->
  <!--          <input-->
  <!--            matInput-->
  <!--            [matDatepicker]="archiveEndPicker"-->
  <!--            formControlName="endDate"-->
  <!--            [max]="maxDate"-->
  <!--            placeholder="MM/DD/YYYY"-->
  <!--            autocomplete="off"-->
  <!--          />-->
  <!--          <mat-datepicker-toggle matSuffix [for]="archiveEndPicker"></mat-datepicker-toggle>-->
  <!--          <mat-datepicker #archiveEndPicker></mat-datepicker>-->
  <!--        </mat-form-field>-->

  <!--        <button mat-flat-button color="primary" (click)="downloadArchive()" class="mb-4">-->
  <!--          <mat-icon>archive</mat-icon>-->
  <!--          Download Archive-->
  <!--        </button>-->
  <!--      </form>-->
  <!--    </mat-card-content>-->
  <!--  </mat-card>-->

  <!-- Section 2: Individual Dataset Downloads Table -->
  <mat-card class="mt-3">
    <mat-card-content>
      <div class="dataset-table-wrapper">
        <table mat-table [dataSource]="datasets" class="dataset-table mat-elevation-z0">
          <!-- Dataset Name Column -->
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef class="table-header">{{ translationService.translate('datasetNameText') }}</th>
            <td mat-cell *matCellDef="let row">{{ translationService.translate(row.nameKey) }}</td>
          </ng-container>

          <!-- Dataset Description Column -->
          <ng-container matColumnDef="description">
            <th mat-header-cell *matHeaderCellDef class="table-header">{{ translationService.translate('datasetDescriptionText') }}</th>
            <td mat-cell *matCellDef="let row">{{ translationService.translate(row.descriptionKey) }}</td>
          </ng-container>

          <!-- Start Date Column -->
          <ng-container matColumnDef="startDate">
            <th mat-header-cell *matHeaderCellDef class="table-header">{{ translationService.translate('startDateText') }}</th>
            <td mat-cell *matCellDef="let row">
              <form [formGroup]="row.form">
                <mat-form-field appearance="fill" class="table-date-field" subscriptSizing="dynamic">
                  <input
                    matInput
                    [matDatepicker]="rowStartPicker"
                    formControlName="startDate"
                    [max]="maxDate"
                    placeholder="MM/DD/YYYY"
                    autocomplete="off"
                  />
                  <mat-datepicker-toggle matSuffix [for]="rowStartPicker"></mat-datepicker-toggle>
                  <mat-datepicker #rowStartPicker></mat-datepicker>
                </mat-form-field>
              </form>
            </td>
          </ng-container>

          <!-- End Date Column -->
          <ng-container matColumnDef="endDate">
            <th mat-header-cell *matHeaderCellDef class="table-header">{{ translationService.translate('endDateText') }}</th>
            <td mat-cell *matCellDef="let row">
              <form [formGroup]="row.form">
                <mat-form-field appearance="fill" class="table-date-field" subscriptSizing="dynamic">
                  <input
                    matInput
                    [matDatepicker]="rowEndPicker"
                    formControlName="endDate"
                    [min]="row.endDateMin"
                    [max]="row.endDateMax"
                    placeholder="MM/DD/YYYY"
                    autocomplete="off"
                  />
                  <mat-datepicker-toggle matSuffix [for]="rowEndPicker"></mat-datepicker-toggle>
                  <mat-datepicker #rowEndPicker></mat-datepicker>
                </mat-form-field>
              </form>
            </td>
          </ng-container>

          <!-- Maximum Range Column -->
          <ng-container matColumnDef="maxRange">
            <th mat-header-cell *matHeaderCellDef class="table-header">{{ translationService.translate('maximumRangeText') }}</th>
            <td mat-cell *matCellDef="let row">{{ translationService.translate(row.maxRangeKey) }}</td>
          </ng-container>

          <!-- Action Column -->
          <ng-container matColumnDef="action">
            <th mat-header-cell *matHeaderCellDef class="table-header"></th>
            <td mat-cell *matCellDef="let row" class="action-cell">
              <button mat-flat-button color="primary" (click)="downloadDataset(row)" [disabled]="isLoading(row.key)">
                @if (isLoading(row.key)) {
                <mat-icon class="spin">sync</mat-icon>
                } @else {
                <mat-icon>download</mat-icon>
                }
                <span class="btn-label">{{ translationService.translate('downloadText') }}</span>
              </button>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns" class="dataset-row"></tr>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
  }
</div>
